import { useSiteData } from "@/hooks/useSiteData";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Calculator } from "@/components/site/Calculator";
import { Warning } from "@/components/site/Warning";
import { Testimonials } from "@/components/site/Testimonials";
import { Bento } from "@/components/site/Bento";
import { Steps } from "@/components/site/Steps";
import { DownloadApp } from "@/components/site/DownloadApp";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { useSeo } from "@/components/site/Seo";

export default function Landing() {
  const { rates, settings, content, gacha } = useSiteData();
  useSeo({
    title: "BagiPulsa – Convert Pulsa Jadi Uang & Saldo eWallet",
    description: "Convert pulsa jadi uang dan saldo eWallet di BagiPulsa. Rate tinggi, tanpa biaya admin, proses 1–10 menit untuk Telkomsel, XL/Axis, Three, Indosat, Smartfren.",
    path: "/",
  });
  return (
    <div className="grain relative bg-ink text-paper" data-testid="landing-page">
      <SmoothScroll />
      <Navbar announcement={settings.announcement} gacha={gacha} />
      <main>
        <Hero rates={rates} settings={settings} />
        <Marquee items={content.marquee} />
        <Calculator rates={rates} settings={settings} />
        <Warning />
        <Testimonials settings={settings} />
        <Bento rates={rates} />
        <Steps />
        <DownloadApp settings={settings} />
        <Faq rates={rates} items={content.faq} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
